import React from 'react'
import { Dialog } from 'primereact/dialog';
import { useQuickAction } from '../../Hooks/Features/employeeDashboard/useQuickAction';
import OutpassEntry from '../Gatepass/OutpassEntry/OutpassEntry';

const QuickActions = () => {

    const {  showGatePassPopup, links, setGatePassShowPopup } = useQuickAction();

    return (
        <>
            <div style={{ width: "100%", height: "99%" }} className='d-flex flex-column gap-1 justify-content-center align-items-center'>
                {
                    links?.map((value, index) => {
                        return (
                            <div key={index}>
                                {
                                    value?.count > 0 && <div className='quick-action'>
                                        <div className='count'>{value?.count}</div>
                                    </div>
                                }
                                <div className={`quick-action-btn ${value?.disable ?  "cursor-auto" :"c-pointer"}`} title={value?.name} onClick={value?.click} style={{ background: value?.color, color: "white" }}>
                                    {value?.icon}
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            <Dialog header={() => <div>Gate Pass Request</div>} visible={showGatePassPopup} onHide={() => setGatePassShowPopup(false)} className='modal-large' style={{ maxWidth: "90vw" }} draggable={false}>
                <div>
                    <OutpassEntry />
                </div>
            </Dialog>
        </>
    )
}

export default QuickActions